import {
    isValidVehicleSelectionLngLat,
    type VehicleSelectionInfo,
} from "../../../MapLibre/vehicleSelection/vehicleSelection.types";
import { type DynamicIslandVehicleRealtimePayload } from "../../dynamicIsland.types";

/**
 * Maps map-domain vehicle selection info to a Dynamic Island payload.
 *
 * @param info Vehicle selection from MapComponent, or undefined when deselected.
 * @returns Island payload or undefined when input is invalid.
 */
export function mapVehicleSelectionToDynamicIslandPayload( info: VehicleSelectionInfo | undefined ): DynamicIslandVehicleRealtimePayload | undefined {
    if (
        info === undefined ||
        info.tripId === "" ||
        !isValidVehicleSelectionLngLat( info.lngLat )
    ) {
        return undefined;
    }

    return {
        "kind":    "vehicleRealtime",
        "tripId":  info.tripId,
        "content": info.content,
        "lngLat":  info.lngLat,
    };
}
